import { Pipe, PipeTransform, Inject } from '@angular/core';

import * as Utils from '@shared/core/utils';
import * as Tokens from '@shared/core/tokens';

@Pipe({
    name: 'pickupLabel'
})
export class PickupLabelPipe implements PipeTransform {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }
    transform(value: OLO.Ordering.IPickupTime | string, type: OLO.Types.PICKUP_LABEL_TYPES = 'common', format: string = 'ddd, D MMM'): string {
        if (!value) return Utils.Pickups.createPickupLabelName(
            this.config.futureOrders,
            type,
            new Date(),
            true,
            format,
        );
        if (typeof value === 'string') {
            const converted: Date = Utils.Dates.createDate(value);
            if (converted.toString() === 'Invalid Date') return value;

            return Utils.Pickups.createPickupLabelName(
                this.config.futureOrders,
                type,
                converted,
                Utils.Dates.datesDiffInDays(new Date(), converted) === 0,
                format,
            );
        }

        return Utils.Pickups.createPickupLabelName(
            this.config.futureOrders,
            type,
            value.DateLocalISO,
            value.IsAsap,
            format,
        );
    }

}
